import styled from '@emotion/styled';
import { useState } from 'react';
import { useMemoizedFn, useRequest } from 'ahooks';
import { message, Tabs } from 'antd';
import { useTranslate } from '@tolgee/react';
import { getBalance } from 'services/api/whatsapp';
import WACosts from './SubRoutes/WACosts';
import balanceImg from './balance.png';
import { numDisplay } from './helpers';
import TopupRecords from './SubRoutes/TopupRecords';
import Topup from './SubRoutes/Topup';

const Container = styled.div`
  padding: 24px;
  .total {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;
const Banner = styled.div`
  height: 72px;
  width: 100%;
  background-color: #fff7ea;
  margin-bottom: 16px;
  border-radius: 4px;
  color: #df8538;
  font-size: 16px;
  white-space: pre;
  img {
    height: 100%;
    margin-right: 6px;
  }
`;
const Content = styled.div`
  background-color: var(--fett-bg-panel);
  padding: 0 10px;
`;

enum waTabKeysEnum {
  Topup,
  TopupRecords,
  Costs,
}

type WaTabKeys = keyof typeof waTabKeysEnum;
const WhatsappWallet = () => {
  const { t } = useTranslate();
  const [activeTabKey, setActiveTabKey] = useState<WaTabKeys>('Topup');
  const { data: balanceDetail } = useRequest(getBalance, {
    onError() {
      message.error(t('WhatsApp.获取whatsapp帐号余额失败'));
    },
  });
  return (
    <Container>
      <Banner>
        <img src={balanceImg} alt="" />
        {t('WhatsApp.账户余额x', { x: numDisplay(balanceDetail?.balance) })}
      </Banner>
      <Content>
        <Tabs
          activeKey={activeTabKey}
          onChange={(tabKey) => {
            setActiveTabKey(tabKey as unknown as WaTabKeys);
          }}
          destroyInactiveTabPane
        >
          <Tabs.TabPane tab={t('WhatsApp.点券充值')} key={waTabKeysEnum[waTabKeysEnum.Topup]}>
            <Topup
              onPayed={useMemoizedFn(() => {
                setActiveTabKey('TopupRecords');
              })}
            />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={t('WhatsApp.充值记录')}
            key={waTabKeysEnum[waTabKeysEnum.TopupRecords]}
          >
            <TopupRecords />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('WhatsApp.消费记录')} key={waTabKeysEnum[waTabKeysEnum.Costs]}>
            <WACosts />
          </Tabs.TabPane>
        </Tabs>
      </Content>
    </Container>
  );
};

export default WhatsappWallet;
